// País del usuario por IP (ipapi.co), compartido por la detección de idioma
// (translateService), el país de las publicaciones (homeUtils.getCountryFromIP)
// y el registro de accesos del login.
//
// ipapi.co limita los pedidos por IP y, pasado el límite, responde 429 sin
// header CORS (en consola se ve como error de CORS). Antes cada uno de esos
// lugares pegaba por su cuenta y la detección de idioma reintentaba en cada
// carga mientras fallaba. Acá:
// - el resultado se guarda en localStorage por CACHE_TTL_MS,
// - los pedidos simultáneos comparten una sola llamada,
// - si falla, no se vuelve a intentar hasta pasado FAILURE_COOLDOWN_MS.

const CACHE_KEY = "ipLocationCache";
const FAILURE_KEY = "ipLocationFailedAt";
const CACHE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
const FAILURE_COOLDOWN_MS = 6 * 60 * 60 * 1000;

let inFlight = null;

const readStorage = (key) => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const writeStorage = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch {}
};

// Devuelve { countryCode, countryName } o null si no se pudo obtener.
export const getIpLocation = async () => {
  try {
    const cached = JSON.parse(readStorage(CACHE_KEY) || "null");
    if (cached && Date.now() - cached.savedAt < CACHE_TTL_MS) return cached.location;
  } catch {}

  const failedAt = Number(readStorage(FAILURE_KEY)) || 0;
  if (Date.now() - failedAt < FAILURE_COOLDOWN_MS) return null;

  if (!inFlight) {
    inFlight = (async () => {
      try {
        const response = await fetch("https://ipapi.co/json/");
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        if (data?.error || !data?.country_code) throw new Error(data?.reason || "sin country_code");
        const location = { countryCode: data.country_code, countryName: data.country_name || null };
        writeStorage(CACHE_KEY, JSON.stringify({ location, savedAt: Date.now() }));
        return location;
      } catch (error) {
        writeStorage(FAILURE_KEY, String(Date.now()));
        console.warn("No se pudo obtener el país por IP:", error.message);
        return null;
      } finally {
        inFlight = null;
      }
    })();
  }
  return inFlight;
};
